// the supseven main javascript file

(function (){
})();

(function($) {
    $.breakpoints.init();
	$.navigation.init();
	// $.stickyHeader.init();
	$.contrast.init();
	$.menuSection.init();
	$.iframeResizer.init();

	updateScreenSizeDependencies();
})(jQuery);

var headerElementMarginTop = 100;
function updateScreenSizeDependencies() {
	var headerBackgroundEl = document.querySelector('.header__background');
	if(headerBackgroundEl) {
		headerElementMarginTop = parseInt(window.getComputedStyle(headerBackgroundEl).getPropertyValue('padding-top'));
	}
}
$(window).on('resize', updateScreenSizeDependencies);

$(window).on('scroll', function onWindowScroll(){
	if($('body').hasClass('tmpl-Homepage')){
		var contentEl = document.querySelector('.main');
		var isHeaderSticky = false;
		if(contentEl) {
			var contentElRect = contentEl.getBoundingClientRect();
			isHeaderSticky = contentElRect.top <= headerElementMarginTop;
		}

		$('body').toggleClass('sticky', isHeaderSticky);
	}

	if($('body').hasClass('tmpl-Default')) {
		if ($(window).scrollTop() > 10) {
			if (!$('body').hasClass('type-oer')) {
				$('.header').addClass('shadow');
			}
		} else {
			$('.header').removeClass('shadow');
		}
	}
});
